module.exports = __webpack_public_path__ + "img/icehockey.91be8936.svg";